import React, { useState, useEffect, useRef, Fragment } from "react";
import { sha256 } from "js-sha256";
import { useDispatch } from "react-redux";
import { Typography, Box, Tooltip } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import * as Yup from "yup";
import icon from "./../assests/light-bulb.png";
import refresh from "./../assests/refresh.png";
import { useNavigate } from "react-router-dom";
import pages from "./../../../constants/pages";
import {
  OuterBox,
  SubheaderSection,
  LoadingButton,
  MandatoryNote,
  OTPInput,
  ButtonContainer,
  ResendOTPButton,
  Loader,
  CaptchaDisplay,
} from "./../../../components";
import {
  useAlert,
  useAxiosV2,
  useAxios,
  useComponent,
} from "./../../../hooks/";

const MyComponent = ({
  token,
  visitorId,
  bookingType,
  id,
  setVerificationFailedCount,
  numberOfInputs = 6,
  setVerification,
}) => {
  const inputRefs = useRef([]);
  const { alert } = useAlert();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { loader } = useComponent();
  // const [captcha, setCaptcha] = useState({
  //   captcha: "",
  //   uuid: "",
  //   loading: false,
  // });
  const [uuid, setUuid] = useState("");
  const [CaptchaError, setCaptchaError] = useState(false);
  const [captcha, setCaptcha] = useState("");

  const [aadharOtpGenerated, setAadharOtpGenerated] = useState(false);
  const validationSchema = Yup.object().shape({
    aadhar_number: Yup.string()
      .required("Aadhar Number is required")
      .matches(/^\d{12}$/, "Aadhar Number must be exactly 12 digits"),
    captchaInput: Yup.string()
      .required("Aadhar Captcha Input is required")
      .test("captchaMatch", "Captcha does not match", function (value) {
        return value === captcha;
      }),
  });

  const dispatch = useDispatch();

  const axiosAadhar = useAxiosV2({ baseURL: "aadharUrl" });
  const axios = useAxios();

  // const handleRefreshCaptcha = () => {
  //   fetchCaptcha(token);
  // };

  const handleGoBack = () => {
    setVerification(false);
  };

  const handleOtpGoBack = () => {
    setAadharOtpGenerated(false);
  };

  const handleChange = (index, value) => {
    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);

    if (value !== "" && index < numberOfInputs - 1) {
      newOTP[index + 1] = "";
      setOTP(newOTP);
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && index > 0 && otp[index] === "") {
      const newOTP = [...otp];
      newOTP[index - 1] = "";
      setOTP(newOTP);
      inputRefs.current[index - 1].focus();
    }
  };

  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomCaptcha = "";
    for (let i = 0; i < 6; i++) {
      randomCaptcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(randomCaptcha);
  };

  function handleFirstOtp(values) {
    setOTP(new Array(numberOfInputs).fill(""));
    setLoading(true);
    var hashID = sha256(`META5488|KijfgGFw3eMeta|PassMeta`);
    axiosAadhar({
      url: "/enter/aadhar/v2/",
      method: "POST",
      authToken: token,
      data: {
        headers: {
          client_code: "META5488",
          sub_client_code: "META5488",
          function_code: "DEFAULT",
          function_sub_code: "DEFAULT",
        },
        request: {
          sub_client_code: "META5488",
          aadhaar: values.aadhar_number,
          hash: hashID,
        },
      },
    }).then((response) => {
      if (response.response_code === 101) {
        setLoading(false);
        if (response.data.response_status.code === "000") {
          dispatch(
            alert({
              type: "success",
              message: "OTP sent on the registered number.",
            })
          );

          setAadharOtpGenerated(true);
          const data = {
            visitor_id: visitorId,
            aadhar_otp_generated: 1,
            doc_type: "aadhar",
          };
          setUuid(response.data.response_data.uuid);
          updateVerificationDetails(data);
        } else if (response.data.response_status.code === "471007") {
          dispatch(
            alert({
              type: "error",
              message: "Please enter a valid captcha.",
            })
          );
        } else if (
          response.data?.response_status?.code === "422005" ||
          response.data.response_status.code === "470046"
        ) {
          dispatch(
            alert({
              type: "error",
              message: response.data?.response_status?.message,
            })
          );
        }
      } else {
        setLoading(false);
        dispatch(
          alert({
            type: "error",
            message: "Error in sending OTP",
          })
        );
      }
    });
  }

  // async function fetchCaptcha(token) {
  //   var requestID = "";
  //   while (requestID.length < 16) {
  //     requestID += Math.random().toString(36).substring(2);
  //   }
  //   requestID = requestID.substring(0, 16);
  //   var hashID = sha256(`META5488|${requestID}|KijfgGFw3eMeta|PassMeta`);

  //   setLoading(true);
  //   setCaptcha((prevVal) => ({
  //     ...prevVal,
  //     loading: true,
  //   }));

  //   axiosAadhar({
  //     url: "/get/captcha/",
  //     method: "POST",
  //     data: {
  //       headers: {
  //         client_code: "META5488",
  //         sub_client_code: "META5488",
  //         channel_code: "web",
  //         channel_version: "1",
  //         stan: "234fdfgb",
  //         client_ip: "",
  //         transmission_datetime: "1624812328201",
  //         operation_mode: "SELF",
  //         run_mode: "",
  //         actor_type: "DEFAULT",
  //         user_handle_type: "EMAIL",
  //         user_handle_value: "abc@gmail.com",
  //         function_code: "DEFAULT",
  //         function_sub_code: "DEFAULT",
  //       },
  //       request: {
  //         api_key: "h73j93ja092",
  //         request_id: requestID,
  //         hash: hashID,
  //       },
  //     },
  //     authToken: token,
  //   })
  //     .then((response) => {
  //       if (response.response_code === 101) {
  //         setCaptcha({
  //           captcha: response.data.response_data.captcha,
  //           uuid: response.data.response_data.uuid,
  //           loading: false,
  //         });

  //         const data = {
  //           visitor_id: visitorId,
  //           aadhar_captcha_generated: 1,
  //           booking_type: bookingType,
  //           id: id,
  //           doc_type: "aadhar",
  //         };
  //         updateVerificationDetails(data);
  //       } else {
  //         setLoading(false);
  //         dispatch(
  //           alert({
  //             type: "error",
  //             message: "Error in loading captcha, please request a new one.",
  //           })
  //         );

  //         setCaptcha({
  //           captcha: "",
  //           uuid: "",
  //           loading: true,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       // Handle captcha loading error
  //       console.error("Error fetching captcha:", error);

  //       dispatch(
  //         alert({
  //           type: "error",
  //           message: "Error in loading captcha, please request a new one.",
  //         })
  //       );
  //       setCaptcha({
  //         captcha: "",
  //         uuid: "",
  //         loading: true,
  //       });
  //     });
  // }

  // useEffect(() => {
  // const fetchData = async () => {
  //   loader.start();
  //   if (token) {
  //     try {
  //       await fetchCaptcha(token);
  //     } finally {
  //       loader.stop();
  //     }
  //   }
  // };
  // fetchData();
  //   loader.stop();
  // }, [loader, token]);

  useEffect(() => {
    generateCaptcha();
  }, []);

  const updateVerificationDetails = (data, step = null) => {
    axios({
      url: `/booking/appointment/verification`,
      method: "PATCH",
      data: { ...data },
    })
      .then((response) => {
        if (response.status) {
          setLoading(false);
          if (step) {
            data.is_verified = 1;
            const payloadString = JSON.stringify(data);
            localStorage.setItem("userPayload", payloadString);
            navigate(pages.checkLiveliness.route, {
              state: {
                visitor_id: visitorId,
              },
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error update details:", error);
      });
  };

  const handleVerifyOTP = () => {
    const otpString = otp.join("");
    const numericOtpString = otpString.replace(/\D/g, "");
    const numericOtp = parseInt(numericOtpString, 10);

    if (isNaN(numericOtp) || numericOtpString.length !== 6) {
      dispatch(
        alert({
          type: "error",
          message: "Invalid OTP. Please enter a 6-digit numeric code.",
        })
      );
      return;
    }
    setLoading(true);
    axiosAadhar({
      url: "/enter/otp/v2/",
      method: "POST",
      authToken: token,
      data: {
        headers: {
          client_code: "META5488",
          sub_client_code: "META5488",
          function_code: "DEFAULT",
          function_sub_code: "DEFAULT",
        },
        request: {
          uuid: uuid,
          otp: numericOtp.toString(),
        },
      },
    }).then((response) => {
      if (response.response_code === 101) {
        if (
          response.data?.response_status?.code === "422002" ||
          response.data?.response_status?.code === "422003" ||
          response.data?.response_status?.code === "333" ||
          response.data?.response_status?.code === "470021"
        ) {
          dispatch(
            alert({
              type: "error",
              message: response.data?.response_status?.message,
            })
          );
          setVerificationFailedCount((prevCount) => prevCount + 1);
          setLoading(false);
        } else if (response.data?.response_status?.code === "000") {
          const name = response.data.response_data.name;
          const nameParts = name.split(" ");
          const first_name = nameParts[0];
          let last_name = nameParts.slice(1).join(" ");
          if (last_name.trim() === "") {
            last_name = first_name;
          }
          const initialDate = response.data.response_data.dob;
          const [day, month, year] = initialDate.split("/");
          const formattedDate = `${day}-${month}-${year}`;
          let payload = {
            doc_type: "aadhaar",
            booking_type: bookingType,
            aadharNo: response.data.response_data.document_id,
            visitor_id: visitorId,
            first_name: first_name,
            last_name: last_name,
            gender: response.data.response_data.gender,
            dob: formattedDate,
            address: response.data.response_data.address,
            doc_face_image: response.data.response_data.doc_face,
          };
          const step = 1;
          updateVerificationDetails(payload, step);
        } else {
          dispatch(
            alert({
              type: "error",
              message: response.data?.response_status?.message,
            })
          );
          setVerificationFailedCount((prevCount) => prevCount + 1);
          setLoading(false);
        }
      }
    });
  };

  const [otp, setOTP] = useState(new Array(numberOfInputs).fill(""));

  const onSubmit = async (values) => {
    try {
      handleFirstOtp(values);
    } catch (error) {
      dispatch(
        alert({
          type: "error",
          message: error,
        })
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      aadhar_number: "",
      captchaInput: "",
    },
    validationSchema,
    onSubmit,
  });

  const handleAadharNumberChange = (event) => {
    const inputNumber = event.target.value;
    const cleanedInput = inputNumber.replace(/\D/g, "");
    const truncatedInput = cleanedInput.slice(0, 12);
    formik.handleChange(event);
    formik.setFieldValue("aadhar_number", truncatedInput);
  };

  if (!aadharOtpGenerated) {
    return (
      // <Loader>
      <OuterBox>
        <SubheaderSection
          textAlign="left"
          title="Aadhar Verification"
          content="Enter your Aadhar details to continue"
        />

        <form>
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            label={
              <Fragment>
                Enter 12 Digit Aadhar Number
                <span
                  style={{
                    color: "red",
                    float: "right",
                    paddingLeft: "5px",
                  }}
                >
                  *
                </span>
              </Fragment>
            }
            inputProps={{
              type: "tel",
              maxLength: 12,
            }}
            name="aadhar_number"
            value={formik.values.aadhar_number}
            onChange={handleAadharNumberChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.aadhar_number &&
              Boolean(formik.errors.aadhar_number)
            }
          />

          <TextField
            label={
              <Fragment>
                Enter Captcha
                <span
                  style={{
                    color: "red",
                    float: "right",
                    paddingLeft: "5px",
                  }}
                >
                  *
                </span>
              </Fragment>
            }
            fullWidth
            margin="normal"
            variant="outlined"
            placeholder="Enter Captcha"
            name="captchaInput"
            value={formik.values.captchaInput}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.captchaInput && Boolean(formik.errors.captchaInput)
            }
            helperText={formik.errors.captchaInput}
            inputProps={{
              maxLength: 6,
            }}
            autoComplete="off"
          />

          {/* <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              padding="20px"
            >
              <img
                src={"data:image/png;base64," + captcha.captcha}
                alt="CAPTCHA"
                style={{
                  display: "inline-block",
                  padding: "5px",
                }}
              /> */}

          {/* Refresh CAPTCHA */}
          {/* <Tooltip title="Refresh CAPTCHA">
                <Box
                  style={{
                    display: "inline-block",
                    textAlign: "center",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                  onClick={handleRefreshCaptcha}
                >
                  <img
                    src={refresh}
                    alt="CAPTCHA"
                    style={{
                      width: "36px",
                      height: "36px",
                    }}
                  />
                </Box>
              </Tooltip>
            </Box> */}

          {/* <Box
              display="flex"
              alignItems="center"
              sx={{
                background: "#E2F1FF",
                borderRadius: "5px",
                p: "10px",
              }}
            >
              <img src={icon} alt={icon} />
              <Typography
                variant="body"
                sx={{
                  textAlign: "center",
                }}
              >
                A verification OTP will be sent to your mobile number linked
                with your Aadhar card
              </Typography>
            </Box> */}

          <CaptchaDisplay captcha={captcha} generateCaptcha={generateCaptcha} />

          <ButtonContainer>
            <LoadingButton loading={loading} onClick={formik.handleSubmit}>
              Send OTP
            </LoadingButton>

            <LoadingButton onClick={handleGoBack} backgroundColor="gray">
              Back
            </LoadingButton>
          </ButtonContainer>

          <MandatoryNote />
        </form>
      </OuterBox>
      // </Loader>
    );
  }

  return (
    <Loader>
      <OuterBox>
        <SubheaderSection
          textAlign="left"
          title="Aadhar Verification"
          content="Enter the 6 digit OTP received on your Aadhar linked mobile number"
        />

        <form>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
              marginTop: "20px",
            }}
          >
            {otp.map((value, index) => (
              <OTPInput
                key={index}
                index={index}
                value={value}
                otp={otp}
                inputRefs={inputRefs}
                otpLength={numberOfInputs}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              />
            ))}
          </div>

          <ButtonContainer>
            <LoadingButton loading={loading} onClick={handleVerifyOTP}>
              Verify Aadhar
            </LoadingButton>

            <LoadingButton onClick={handleOtpGoBack} backgroundColor="gray">
              Back
            </LoadingButton>
          </ButtonContainer>

          <ResendOTPButton onClick={formik.handleSubmit} disabled={loading} />
        </form>
      </OuterBox>
    </Loader>
  );
};

export default MyComponent;
